import { toast } from 'sonner';
import type { ErroISolve } from '../services/api';

// Exibe o toast certo para cada discriminador de erro iSolve.
// Extraído de KanbanBoard.tsx (SPEC 3) para reuso em NovaOperacaoModal.tsx
// (caminho "Buscar no iSolve" - mesmos erros de sessão do fluxo normal).
export function toastErroISolve(erro: ErroISolve, navigate: (p: string) => void) {
  if (erro === 'SESSAO_EXPIRADA') {
    toast.error('Sessão iSolve expirada.', {
      action: { label: 'Reconectar', onClick: () => navigate('/conectar-isolve') },
      duration: 8000,
    });
  } else if (erro === 'SEM_SESSAO') {
    toast.error('Sessão iSolve não configurada.', {
      action: { label: 'Conectar', onClick: () => navigate('/conectar-isolve') },
      duration: 8000,
    });
  } else if (erro === 'SESSAO_SUSPEITA') {
    toast.warning('Instabilidade detectada na sessão iSolve. Pode normalizar sozinha; se persistir, reconecte.', {
      duration: 6000,
    });
  } else {
    toast.warning('Instabilidade no iSolve - tente novamente.', { duration: 5000 });
  }
}
